import { render, staticRenderFns } from "./TasksDropdown.vue?vue&type=template&id=3f4a16d0&"
import script from "./TasksDropdown.vue?vue&type=script&lang=ts&"
export * from "./TasksDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports